<template>
  <div class="shop-tab">
    <van-sticky>
      <!-- 排序 -->
      <sortbar-vue :source="navData" @click-event="navChange"></sortbar-vue>
    </van-sticky>
    <van-popup v-model="navData.showSearchPanel" position="right" :style="{ width:'80%',height:'100%' }" :overlay-style="{backgroundColor: 'rgba(0,0,0,.6)'}" get-container="body">
      <!-- 搜索弹窗 -->
      <shop-filter-vue @change-event="changeSearchParams"></shop-filter-vue>
    </van-popup>
    <van-list v-model="ajaxInfo.loading" :finished="ajaxInfo.finished" finished-text="没有更多了" @load="loadMore">
      <div :class="navData.direction=='horizontal'?'shop-list-ui':'shop-grid-ui'">
        <div v-for="(item,index) in shopList" :key="index" :class="navData.direction=='horizontal'?'shop-list':'shop-grid'" @click="goShop(item.shopWapUrl,item,index)">
          <div class="shop-item-box">
            <div class="shop-img">
              <img :src="item.shopLogo" alt="" @error="nofind_pic()">
            </div>
            <div class="shop-info">
              <p class="shop-title">{{ item.shopName }}</p>
              <p class="shop-star">
                <van-rate v-model="item.shopLevel" disabled :count="item.shopLevel" color="#FA6101" disabled-color="#FA6101" size="8" />
              </p>
            </div>
            <div class="shop-btn" v-if="navData.direction=='horizontal'">
              <span class="buttom" @click="goShop(item.shopWapUrl,item,index)">进店</span>
            </div>
          </div>
          <!-- temp组件部分 -->
          <div class="blow-card" v-show="item.products.length > 0 && navData.direction=='horizontal'">
            <div class="shop-list" ref="swper">
              <div class="shop-cont" v-for="(val, index1) in item.products" :key="index1">
                <div :class="[index < 2 ? 'item mg-21': 'item']">
                  <a href="javascript:void(0)" @click="goPage(val.pId,item,index1,index,val)">
                    <div class="it-img">
                      <img :src="val.fileNameDefault" @error="nofind_pic()" />
                    </div>
                    <div class="it-desc">
                      {{ val.name }}
                    </div>
                    <div class="it-price">
                      <span>￥</span><span>{{ val.price }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
let vm = null
import sortbarVue from './sortbar.vue'
import productFilterVue from './productFilter.vue'
import shopFilterVue from './shopFilter.vue'
import { mixin } from '../mixin'
import { getShopList, getConditionOld } from '../../../request/search.js'

export default {
  components: {
    sortbarVue,
    productFilterVue,
    shopFilterVue,
  },
  mixins: [mixin()],
  data() {
    return {
      shopList: [],
      searchPannelInfo: {
        categoryId1: '',
      },
    }
  },
  mounted() {
    vm = this
  },
  methods: {
    init() {
      this.$set(this.navData, 'sortBy', 'MULTIPLE')
      this.$set(this.navData, 'sortList', [
        {
          label: '综合',
          value: ['MULTIPLE'],
        },
        {
          label: '销量',
          value: ['SALE_COUNT'],
        },
        {
          label: '评价',
          value: ['EVALUATE'],
        },
      ])
      this.pageData.size = 20
      this.searchPannelInfo.categoryId1 = this.filterObj.categoryLevel == 3 ? this.filterObj.categoryLevel.categoryId : ''
    },

    getDataList() {
      let param = {
        page: this.pageData.page,
        pageSize: this.pageData.size,
        keyword: this.filterObj.keyword,
        sort: this.navData.sortBy,
        isReturnProduct: true,
        categoryId1: Number(this.searchPannelInfo.categoryId1 || 0),
        shopType: this.searchPannelInfo.shopType || 'ALL',
      }
      getShopList(param).then((res) => {
        this.ajaxInfo.loading = false
        let { data, respCode } = res.data
        if (respCode == '0000') {
          let pageData = data.items || []
          if (this.pageData.page == 1 && !pageData.length) {
            location.href = `${$HMD$.rApi.M}/h5new/search/empty`
            //无自然搜索商品结果埋点
            this.yiGuanSearch('null_natural_search_result_display', 0)
            return false
          }
          if (pageData.length < this.pageData.size) {
            this.ajaxInfo.finished = true
          }
          pageData.forEach((item) => {
            item.shopLevel = Number(item.shopLevel)
            item.products.length > 0 ? this.$set(item, 'catchMsg', true) : this.$set(item, 'catchMsg', false)
            if (item.products.length > 3) {
              item.products = item.products.slice(0, 3)
            }
          })
          if (this.pageData.page == 1) {
            this.shopList = []
          }
          this.shopList = this.shopList.concat(pageData)
          this.pageData.page++
          this.yiGuanSearch('natural_search_result_display', res.data.count)
        }
      })
    },
    // changeSearchParams(emitData = {}, closeSearchPanel = true) {
    //   this.pageData.page = 1
    //   this.navData.showSearchPanel = !closeSearchPanel
    //   if (Object.keys(emitData).length > 0) {
    //     this.navData.searchInfo = true
    //     this.searchPannelInfo = emitData
    //   } else {
    //     this.navData.searchInfo = false
    //   }

    //   this.getDataList()
    // },
    //进店
    goShop(url, item, index) {
      $HMD$.aYiGuan('search_result_click', null, {
        content_type: '店铺',
        is_filter: Number(this.searchPannelInfo.categoryId1 || 0) || (this.searchPannelInfo.shopType != 'ALL' && this.searchPannelInfo.shopType != '') ? true : false,
        filter_detail: this.searchPannelInfo.categoryId1 + ',' + this.searchPannelInfo.shopType,
        btn_name: '进店',
        page_num: this.pageData.page,
        item_id: item.shopId,
        item_code: '',
        item_name: item.shopName,
        first_category: '',
        second_category: '',
        third_category: '',
        price: 0,
      })
      window.open(url)
    },
    //查看商品
    goPage(itemId, val) {
      let url = `${$HMD$.rApi.M}/shop/goods/fullDetail?itemId=${itemId}`
      $HMD$.aYiGuan('search_result_click', null, {
        content_type: '商品',
        is_filter: Number(this.searchPannelInfo.categoryId1 || 0) || (this.searchPannelInfo.shopType != 'ALL' && this.searchPannelInfo.shopType != '') ? true : false,
        filter_detail: this.searchPannelInfo.categoryId1 + ',' + this.searchPannelInfo.shopType,
        btn_name: '商品',
        page_num: this.pageData.page,
        item_id: val.pId,
        item_code: '',
        item_name: val.name,
        first_category: val.categoryId1,
        second_category: '',
        third_category: '',
        price: val.price,
      })
      window.open(url)
    },
    yiGuanSearch(type, num = 0) {
      $HMD$.aYiGuan(type, null, {
        $referrer: document.referrer,
        content_type: '店铺',
        $search_keyword: this.filterObj.keyword,
        keyword_type: '其他',
        is_filter: Number(this.searchPannelInfo.categoryId1 || 0) || (this.searchPannelInfo.shopType != 'ALL' && this.searchPannelInfo.shopType != '') ? true : false,
        filter_detail: this.searchPannelInfo.categoryId1 + ',' + this.searchPannelInfo.shopType,
        shop_num: num,
      })
    },
  },
}
</script>
<style lang="less" scoped>
.van-list {
  padding-top: 1rem;
}
</style>
<style lang="less">
@import "../../../assets/style/theme.less";
.shop-list {
  margin-top: 10px;
  background: #fff;
  border-radius: 5px;
  margin: 10px 12px 0;
  padding: 1rem;
  .shop-item-box {
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    .shop-img {
      width: 5.7rem;
      height: 5.7rem;
      img {
        width: 4.5rem;
        height: 4.5rem;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #dee2e9;
      }
    }
    .shop-info {
      flex: 1;
      margin-top: 5px;
      .shop-title {
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
        font-size: 14px;
        font-weight: 700;
        color: #1e1f22;
      }
      .shop-star {
        margin-top: 0.5rem;
        display: inline-flex;
        height: 17px;
        background: #efeeee;
        border-radius: 8px;
        justify-content: center;
        align-items: center;
        padding: 0 12px 0px 8px;
      }
    }
    .shop-btn {
      width: 48px;
      margin-top: 6px;
      border-radius: 5px;
      right: 1px;
      align-self: flex-start;
      .buttom {
        display: block;
        width: 48px;
        height: 24px;
        background: linear-gradient(90deg, #0a97ff, @hmd-primary-color);
        border-radius: 2px;
        font-size: 12px;
        color: #fff;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
.blow-card {
  font-family: PingFangSC-Semibold, PingFang SC;
  overflow: hidden;
  width: 100%;
  .blowUp {
    display: flex;
    height: 40px;
    line-height: 40px;
    margin: 0 12px;
    .b-cont {
      flex: 1;
      width: 0;
      display: flex;
      .b-tle {
        padding-left: 4px;
        color: #1e1f22;
        font-size: 18px;
        font-weight: 600;
      }
      .b-desc {
        margin-left: 10px;
        font-size: 12px;
        color: #4b4d55;
        font-weight: 400;
      }
    }
    .b-more {
      font-size: 12px;
      font-weight: 400;
      color: #4b4d55;
      span {
        display: inline-block;
        vertical-align: middle;
        width: 12px;
        height: 12px;
        /* background: url("../../../asset/images/list-icon.png") no-repeat; */
        background-size: cover;
      }
    }
  }
  .bgcM {
    background-color: @hmd-bg-color;
    width: 100%;
    height: 5px;
    position: absolute;
    top: -25px;
  }
  .shop-list {
    display: flex;
    overflow: hidden;
    padding: 16px 10px 10px 10px;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    .shop-cont {
      width: 31%;
      height: 90%;
      margin-right: 3%;
      .item {
        width: 100%;
        height: 100%;
        position: relative;
        .it-img {
          height: 80px;
          width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 80%;
            height: auto;
          }
        }
        .shop-name {
          font-size: 10px;
          color: #787878;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 80px;
          margin-left: 5px;
        }
        .it-desc {
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-top: 4px;
          height: 36px;
          width: 100%;
          line-height: 18px;
          padding: 0 5px;
          box-sizing: border-box;
          font-weight: normal;
          span {
            font-size: 10px;
            display: inline-block;
            float: left;
            margin-top: 1px;
            padding: 0 5px;
            height: 14px;
            background: linear-gradient(270deg, #fd7055 0%, #ff2c24 100%);
            border-radius: 0px 6px 0px 6px;
            color: #fff;
            border-radius: 0 3px 0 3px;
            text-align: center;
            line-height: 13px;
            margin-right: 6px;
          }
        }
        .it-price {
          height: 28px;
          box-sizing: border-box;
          vertical-align: bottom;
          color: #e52b2b;
          padding: 4px 5px 0;
          font-size: 18px;
          position: relative;
          bottom: 0px;
          overflow: hidden;
          span:nth-child(1) {
            font-size: 10px;
            color: #e52b2b;
          }
          span:nth-child(3) {
            font-size: 10px;
          }
        }
        .del-price {
          text-decoration: line-through;
          font-size: 9px;
          color: #7d7f88;
        }
      }
      .mg-21 {
        margin-right: 3px;
      }
    }
    .shop-cont:nth-child(3) {
      margin-right: 0;
    }
    .custom-indicator {
      position: absolute;
      bottom: 15px;
      left: 50%;
      transform: translate(-50%);
      span {
        display: inline-block;
        width: 16px;
        height: 2px;
        background-color: #eaf1ff;
      }
      .active {
        background-color: @hmd-primary-color;
      }
    }
  }
  .shop-list::-webkit-scrollbar {
    display: none;
  }
}
.shop-grid-ui {
  display: flex;
  flex-flow: wrap;
  .shop-grid {
    width: 31%;
    margin-left: 1.7%;
    background-color: #fff;
    margin-bottom: 1rem;
    border-radius: 1rem;
    text-align: center;
    .shop-item-box {
      .shop-img {
        text-align: center;
        width: 6rem;
        display: block;
        height: 6rem;
        margin: 1rem auto;
        img {
          width: 6rem;
          height: 6rem;
        }
      }
      .shop-info {
        .shop-title {
          font-weight: 700;
          width: 90%;
          margin: 0 auto;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 2rem;
          white-space: nowrap;
        }
        .shop-star {
          width: 68px;
          height: 17px;
          background: #efeeee;
          border-radius: 8px;
          margin: 1rem auto 3rem;
        }
      }
    }
  }
}
</style>
